import { render, staticRenderFns } from "./PutawayRules.vue?vue&type=template&id=e433e18e"
import script from "./PutawayRules.vue?vue&type=script&lang=js"
export * from "./PutawayRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports